import React, {useState, useRef, useEffect} from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import PlayButton from '@commonComponents/PlayButton';
// import videoUrl from '@assets/videos/brand.mov';
// import videoPoster from '@common/assets/images/poster.webp';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
};
  

function VideoModal({posterImage, videoUrl, videoImage}) {

    const videoRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [videoDimensions, setVideoDimensions] = useState({ width: '80vw', height: 'auto' });

    const handleOpen = () => {
        setOpen(true);
        setTimeout(() => {
            if (videoRef.current) {
                videoRef.current.play();
            }
        }, 500)
    }
    
    const handleClose = () => {
        setOpen(false);
        setTimeout(() => {
            if (videoRef.current) {
                videoRef.current.pause();
                videoRef.current.currentTime = 0;
            }
        }, 500)
    }

    const handleLoadedMetadata = () => {
        if (videoRef.current) {
            const video = videoRef.current;
            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;
            
            // Calculate dimensions based on viewport
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const isMobile = viewportWidth < 768;
            
            let maxWidth = isMobile ? viewportWidth * 0.9 : viewportWidth * 0.8;
            let maxHeight = isMobile ? viewportHeight * 0.7 : viewportHeight * 0.85;
            
            let finalWidth = maxWidth;
            let finalHeight = finalWidth / aspectRatio;
            
            // If height exceeds max, recalculate based on height
            if (finalHeight > maxHeight) {
                finalHeight = maxHeight;
                finalWidth = finalHeight * aspectRatio;
            }
            
            setVideoDimensions({
                width: `${finalWidth}px`,
                height: `${finalHeight}px`,
                aspectRatio: aspectRatio
            });
        }
    }

    useEffect(() => {
        const handleResize = () => {
            if (open && videoRef.current && videoRef.current.videoWidth) {
                handleLoadedMetadata();
            }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [open]);

  return (
    <>
        <div className='bs-infography__media-wrap cm-pointer' onClick={handleOpen}>
            
            <CloudinaryAdvancedImage imagePublicId={posterImage} className='bs-infography__image' type="full-width-feature-banner"/>

            <PlayButton size="large" />
        </div>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className='bs-modal bs-modal--typ-video'
        >
            <Box 
                className='bs-modal__wrapper' 
                sx={{
                    ...style,
                    width: videoDimensions.width,
                    height: videoDimensions.height,
                    maxWidth: '90vw',
                    maxHeight: '85vh'
                }}
            >
                <button className='bs-btn bs-btn__btn-icon bs-modal__close' onClick={handleClose}>
                    <span className='icon icon-close'></span>
                </button>
                <div className='bs-modal__content'>
                    <video 
                        ref={videoRef} 
                        controls={true} 
                        poster={videoImage} 
                        className='bs-modal__video'
                        onLoadedMetadata={handleLoadedMetadata}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        }}
                    >
                        <source src={videoUrl} type="video/mp4" />
                    </video>
                </div>
            </Box>
        </Modal>

    </>
  )
}

export default VideoModal